// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/intro-pic.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Schemes - Uncomment one to use */
/* Active: Dark Mystical (Deep purples and midnight blues) */
:root {
  --primary-start: #2d1b69;
  --primary-end: #11998e;
  --secondary-start: #667eea;
  --secondary-end: #764ba2;
  --accent-start: #4facfe;
  --accent-end: #00f2fe;
  --cta-start: #667eea;
  --cta-end: #764ba2;
}
/* Option 1: Cosmic Noir (Black and deep space blues)
:root {
    --primary-start: #0c0c0c;
    --primary-end: #1a237e;
    --secondary-start: #283593;
    --secondary-end: #1a237e;
    --accent-start: #3f51b5;
    --accent-end: #9c27b0;
    --cta-start: #e91e63;
    --cta-end: #9c27b0;
}
*/
/* Option 2: Enchanted Forest (Deep greens and earth tones)
:root {
    --primary-start: #1b5e20;
    --primary-end: #2e7d32;
    --secondary-start: #388e3c;
    --secondary-end: #1b5e20;
    --accent-start: #4caf50;
    --accent-end: #2e7d32;
    --cta-start: #ff6f00;
    --cta-end: #e65100;
}
*/
/* Option 3: Dragon's Lair (Deep reds and charcoal)
:root {
    --primary-start: #1a1a1a;
    --primary-end: #b71c1c;
    --secondary-start: #d32f2f;
    --secondary-end: #b71c1c;
    --accent-start: #f44336;
    --accent-end: #d32f2f;
    --cta-start: #ff5722;
    --cta-end: #d84315;
}
*/
/* Option 4: Ethereal Mist (Soft purples and silvers)
:root {
    --primary-start: #4a148c;
    --primary-end: #6a1b9a;
    --secondary-start: #7b1fa2;
    --secondary-end: #4a148c;
    --accent-start: #9c27b0;
    --accent-end: #7b1fa2;
    --cta-start: #e1bee7;
    --cta-end: #ce93d8;
}
*/
/* Homepage Styles */
.homepage {
  background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);
  min-height: 100vh;
}
/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, rgba(45, 27, 105, 0.8) 0%, rgba(17, 153, 142, 0.8) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  color: white;
  padding: 100px 0;
  min-height: 80vh;
  display: flex;
  align-items: center;
}
.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.hero-subtitle {
  font-size: 1.25rem;
  font-weight: 300;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto 2rem;
  line-height: 1.6;
}
.cta-button {
  background: linear-gradient(45deg, var(--cta-start), var(--cta-end));
  border: none;
  border-radius: 50px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  background: linear-gradient(45deg, var(--cta-end), var(--cta-start));
}
/* How It Works Section */
.how-it-works-section {
  background: #f8f9fa;
  padding: 80px 0;
}
.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 3rem;
}
.step-card {
  text-align: center;
  padding: 2rem 1rem;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
}
.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto 1.5rem;
}
.step-card h4 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1rem;
}
.step-card p {
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
}
.min-vh-75 {
  min-height: 75vh;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  .hero-subtitle {
    font-size: 1.1rem;
  }
  .section-title {
    font-size: 2rem;
  }
  .hero-section {
    padding: 60px 0;
  }
  .how-it-works-section {
    padding: 60px 0;
  }
}
.fade-up {
  animation: fadeInUp 1.5s ease-out;
  opacity: 0;
  animation-fill-mode: forwards;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(200px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.scroll-animation {
  opacity: 0;
  transform: translateY(200px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}
.scroll-animation.fade-up {
  opacity: 1;
  transform: translateY(0);
}
.custom-input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  margin-bottom: 2em;
}
.custom-input:focus {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.custom-input::placeholder {
  color: #6c757d;
  opacity: 1;
}
.custom-input:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.tab {
  background-color: white;
  color: #6c757d;
  /* Darker color for inactive links */
  transition: color 0.2s ease;
}
.tab.active {
  background-color: #848688 !important;
  color: black !important;
  font-weight: 500;
}
.tab:hover {
  background-color: #bbbdc0;
  color: black !important;
  /* Same as active on hover */
}
.action-button-wrapper {
  z-index: 1000;
}
.action-button {
  position: relative;
}
.main-button {
  width: 48px;
  height: 48px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}
.main-button svg {
  width: 24px;
  height: 24px;
}
.expanded-buttons {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  opacity: 0;
  transform: translateX(10px);
  pointer-events: none;
  transition: all 0.3s ease;
  border-radius: 24px 0 0 24px;
  overflow: hidden;
}
.action-item {
  width: 48px;
  height: 48px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.action-item svg {
  width: 20px;
  height: 20px;
}
/* Hover states */
.action-button:hover .main-button {
  border-radius: 0 24px 24px 0 !important;
  transition: border-radius 0.3s ease;
}
.action-button:hover .expanded-buttons {
  opacity: 1;
  transform: translateX(-3em);
  pointer-events: all;
}
/* Optional: Add animation for the gear icon */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.main-button svg {
  animation: spin 4s linear infinite;
  animation-play-state: paused;
}
.action-button:hover .main-button svg {
  animation-play-state: running;
}
/* Add to your stylesheet */
.table {
  --bs-table-striped-bg: rgba(0, 0, 0, 0.02);
}
.table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}
.table td {
  vertical-align: middle;
}
.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transition: background-color 0.2s ease;
}
/* For sticky header */
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}
/* Custom scrollbar for the table container */
.table-container {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.table-container::-webkit-scrollbar {
  width: 6px;
}
.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
/* Responsive table wrapper */
.table-responsive {
  border-radius: 0.375rem;
  overflow: hidden;
}
.transition-icon {
  transition: all 0.2s ease;
}
.transition-icon:hover {
  transform: rotate(90deg);
  color: var(--bs-primary) !important;
}
.transition-icon-2 {
  transition: all 0.2s ease;
}
.transition-icon-2:hover {
  transform: scale(1.25);
  color: var(--bs-primary) !important;
}
.link-box {
  background-color: '#f8f9fa';
  padding: '10px';
  border-radius: '4px';
}
.intro-pic {
  width: 100;
  z-index: -1;
}
/* Pricing Page Styles */
.pricing-page {
  background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);
  min-height: 100vh;
}
/* Pricing Hero Section */
.pricing-hero {
  background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);
  color: white;
  padding: 100px 0 60px;
}
.pricing-title {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.pricing-subtitle {
  font-size: 1.2rem;
  font-weight: 300;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}
/* Plans Section */
.plans-section {
  background: #f8f9fa;
  padding: 60px 0 100px;
}
/* Pricing Cards */
.pricing-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}
.pricing-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}
.plan-name {
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.5rem;
}
.price-container {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.25rem;
}
.price-symbol {
  font-size: 1.5rem;
  color: var(--secondary-start);
  font-weight: 600;
}
.price-amount {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
}
.price-period {
  font-size: 1rem;
  color: #6c757d;
  font-weight: 400;
}
.plan-button {
  background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));
  border: none;
  border-radius: 50px;
  font-weight: 600;
  padding: 12px 30px;
  transition: all 0.3s ease;
}
.plan-button:hover {
  background: linear-gradient(45deg, var(--secondary-end), var(--secondary-start));
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}
/* Dashboard Styles */
.dashboard-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}
.dashboard-content {
  padding: 2rem 0;
}
/* Modern Action Button */
.modern-action-button {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
}
.modern-action-button .main-button {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: none;
  background: linear-gradient(45deg, #667eea, #764ba2);
}
.modern-action-button .expanded-buttons {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  opacity: 0;
  transform: translateX(10px);
  pointer-events: none;
  transition: all 0.3s ease;
  border-radius: 28px 0 0 28px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.modern-action-button .action-item {
  width: 48px;
  height: 48px;
  border-radius: 0;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modern-action-button:hover .main-button {
  border-radius: 0 28px 28px 0;
}
.modern-action-button:hover .expanded-buttons {
  opacity: 1;
  transform: translateX(-48px);
  pointer-events: all;
}
/* Missionary Tabs */
.missionary-tabs-container {
  margin-bottom: 2rem;
  padding: 0 1rem;
}
.missionary-tabs {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}
.missionary-tab {
  background: white;
  border: none;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: left;
}
.missionary-tab:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.missionary-tab.active {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.tab-name {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.25rem;
}
.tab-email {
  font-size: 0.875rem;
  opacity: 0.8;
}
/* Dashboard Cards */
.dashboard-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
}
.dashboard-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}
/* Modern Dashboard */
.modern-dashboard {
  padding: 1rem 0;
}
/* Section Titles */
.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
}
.section-subtitle {
  color: #6c757d;
  font-size: 0.95rem;
  line-height: 1.5;
}
/* Missionary Details */
.modern-missionary-details .details-grid {
  display: grid;
  gap: 1.5rem;
}
.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.detail-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.detail-value {
  font-size: 1rem;
  font-weight: 500;
  color: #2c3e50;
}
/* Subscription Status */
.subscription-prompt {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  text-align: center;
}
.subscription-prompt h5 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
}
.status-active {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #d4edda, #c3e6cb);
  border-radius: 12px;
  text-align: center;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
}
.status-dot {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.status-active h5 {
  color: #155724;
  margin-bottom: 0.5rem;
}
.email-address {
  background: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-family: monospace;
  font-weight: 500;
  color: #2c3e50;
  border: 2px solid #28a745;
}
/* QR Code Section */
.modern-qr-section {
  text-align: center;
}
.qr-code-container {
  display: flex;
  justify-content: center;
}
.qr-code-wrapper {
  background: white;
  padding: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: inline-block;
}
.qr-code {
  display: block;
}
.link-container {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.link-text {
  font-family: monospace;
  font-size: 0.875rem;
  color: #495057;
  word-break: break-all;
  flex: 1;
}
.link-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}
/* Subscriber Table */
.modern-subscriber-table {
  background: white;
  border-radius: 16px;
  overflow: hidden;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
.edit-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}
.table-wrapper {
  max-height: 400px;
  overflow-y: auto;
}
.modern-table {
  margin: 0;
}
.modern-table th {
  background: #f8f9fa;
  border-top: none;
  font-weight: 600;
  color: #495057;
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 1;
}
.modern-table td {
  padding: 1rem 2rem;
  border-top: 1px solid #f1f3f4;
  vertical-align: middle;
}
.modern-table tbody tr:hover {
  background-color: #f8f9fa;
}
/* Authentication Pages Styles */
.auth-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}
.auth-container {
  padding: 2rem 0;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
}
.min-vh-80 {
  min-height: 80vh;
}
/* Auth Card */
.auth-card {
  background: white;
  border-radius: 20px;
  padding: 3rem 2.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
/* Auth Header */
.auth-header {
  text-align: center;
  margin-bottom: 2rem;
}
.auth-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.75rem;
}
.auth-subtitle {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}
/* Modern Auth Form */
.modern-auth-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
/* Modern Input */
.modern-input {
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  background: #f8f9fa;
  transition: all 0.3s ease;
  outline: none;
}
.modern-input:focus {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.modern-input::placeholder {
  color: #adb5bd;
}
/* Modern Submit Button */
.modern-submit-btn {
  width: 100%;
  padding: 1rem 2rem;
  background: linear-gradient(45deg, #667eea, #764ba2);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.modern-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  background: linear-gradient(45deg, #764ba2, #667eea);
}
.modern-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
/* Auth Error */
.auth-error {
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #fee, #fdd);
  color: #721c24;
  padding: 1rem 1.25rem;
}
.error-list {
  margin: 0;
  padding-left: 1.25rem;
}
.error-list li {
  margin-bottom: 0.25rem;
}
/* Auth Toggle */
.auth-toggle {
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}
.toggle-btn {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}
.toggle-btn:hover {
  color: #764ba2;
  background: rgba(102, 126, 234, 0.1);
  text-decoration: none;
}
/* Forgot Password */
.forgot-password {
  text-align: right;
  margin-top: 0.5rem;
}
.forgot-link {
  color: #667eea;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.3s ease;
}
.forgot-link:hover {
  color: #764ba2;
  text-decoration: underline;
}
/* Missionary Warning */
.missionary-warning {
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;
}
.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
  margin: 0;
}
.checkbox-input {
  margin: 0;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.checkbox-text {
  font-size: 0.875rem;
  color: #856404;
  line-height: 1.4;
}
.checkbox-text a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}
.checkbox-text a:hover {
  text-decoration: underline;
}
/* Success Message */
.success-message {
  text-align: center;
  padding: 2rem 1rem;
}
.success-message h4 {
  color: #28a745;
  font-weight: 600;
  margin-bottom: 1rem;
}
.success-message p {
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
}
/* Responsive Design for Dashboard */
@media (max-width: 768px) {
  .dashboard-content {
    padding: 1rem 0;
  }
  .dashboard-card {
    padding: 1.5rem;
    margin-bottom: 1rem;
  }
  .modern-action-button {
    bottom: 1rem;
    right: 1rem;
  }
  .missionary-tabs {
    flex-direction: column;
  }
  .missionary-tab {
    min-width: auto;
  }
  .table-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .modern-table th,
  .modern-table td {
    padding: 0.75rem 1rem;
  }
}
/* Header Styles */
.modern-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.brand-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.25rem;
}
.logo-img {
  width: 40px;
  height: 40px;
}
.brand-text {
  font-weight: 700;
  color: #2c3e50;
}
.nav-links {
  gap: 1rem;
}
.nav-item {
  color: #495057;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  text-decoration: none;
}
.nav-item:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}
.signin-btn {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
}
.signin-btn:hover {
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.logout-btn:hover {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}
/* Modal Styles */
.modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  height: 75vh;
}
.modal-header {
  border-bottom: 1px solid #f1f3f4;
  padding: 2rem 2rem 1rem;
  width: 100%;
}
.modal-header .btn-close {
  color: white;
}
.modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: whitesmoke;
}
.modal-body {
  padding: 1rem 2rem;
  overflow-y: auto;
  width: 100%;
  scrollbar-width: thin;
  /* Options: auto, thin, none */
}
.modal-footer {
  border-top: 1px solid #f1f3f4;
  padding: 1rem 2rem 2rem;
  gap: 1rem;
  width: 100%;
}
.form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
.cancel-btn {
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
}
.save-btn {
  background: linear-gradient(45deg, #667eea, #764ba2);
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  color: white;
}
.save-btn:hover {
  background: linear-gradient(45deg, #764ba2, #667eea);
  transform: translateY(-1px);
}
.email-confirm {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  font-family: monospace;
  color: #495057;
  border: 2px solid #e9ecef;
}
/* Subscribe Page */
.subscribe-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}
.subscribe-container {
  padding: 4rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
}
.subscribe-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}
.missionary-info {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}
.missionary-name {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}
.mission-details {
  font-size: 1.1rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
.start-date {
  color: #6c757d;
  margin: 0;
}
.subscribe-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.form-header {
  text-align: center;
  margin-bottom: 1rem;
}
.form-header h3 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.form-header p {
  color: #6c757d;
  margin: 0;
}
.subscribe-btn {
  background: linear-gradient(45deg, #667eea, #764ba2);
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-weight: 600;
  color: white;
  transition: all 0.3s ease;
}
.subscribe-btn:hover {
  background: linear-gradient(45deg, #764ba2, #667eea);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.success-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}
.success-icon {
  width: 80px;
  height: 80px;
  background: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  margin: 0 auto 1.5rem;
}
.success-card h3 {
  color: #28a745;
  font-weight: 600;
  margin-bottom: 1rem;
}
.error-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}
.error-card h3 {
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 1rem;
}
/* Not Found Page */
.not-found-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}
.not-found-container {
  padding: 4rem 2rem;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 80px);
}
.not-found-content {
  color: white;
  text-align: center;
}
.error-code {
  font-size: 8rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
.error-title {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.error-message {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}
.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.home-btn {
  background: white;
  color: #667eea;
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-weight: 600;
}
.home-btn:hover {
  background: #f8f9fa;
  color: #764ba2;
  transform: translateY(-2px);
}
/* About Page */
.about-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}
.about-hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 100px 0 60px;
}
.about-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}
.about-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}
.about-content {
  padding: 4rem 0;
}
.content-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.mission-statement {
  margin-bottom: 3rem;
  text-align: center;
}
.mission-statement h2 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1rem;
}
.how-it-works h2 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
}
.steps-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2rem;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 3rem;
}
.step-item {
  text-align: center;
  padding: 0;
}
.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto 1rem;
}
.step-item h4 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.cta-section {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 16px;
}
.cta-section h3 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1rem;
}
/* Content Page */
.content-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}
.page-container {
  padding: 4rem 0;
}
.loading-content {
  text-align: center;
  padding: 4rem 2rem;
}
/* Stripe Components */
.modal-dialog {
  max-width: 800px;
}
.stripe-form {
  padding: 1rem 0;
}
.stripe-loading {
  text-align: center;
  padding: 3rem 2rem;
}
.stripe-loading p {
  margin-top: 1rem;
  color: #6c757d;
}
.plans-selection {
  margin-bottom: 2rem;
}
.plans-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}
.plan-option {
  border: 2px solid #e9ecef;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  background: white;
}
.plan-option:hover {
  border-color: var(--secondary-start);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.plan-header {
  margin-bottom: 1.5rem;
}
.plan-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
}
.plan-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.25rem;
}
.price-amount {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--secondary-start);
}
.price-period {
  font-size: 1rem;
  color: #6c757d;
}
.plan-description {
  color: #6c757d;
  margin-bottom: 2rem;
  line-height: 1.5;
}
.select-plan-btn {
  background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-weight: 600;
  color: white;
  width: 100%;
  transition: all 0.3s ease;
}
.select-plan-btn:hover:not(:disabled) {
  background: linear-gradient(45deg, var(--secondary-end), var(--secondary-start));
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}
.select-plan-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.checkout-container {
  min-height: 400px;
  border-radius: 12px;
  overflow: hidden;
}
/* Responsive Design for Auth Pages */
@media (max-width: 768px) {
  .auth-container {
    padding: 1rem 0;
  }
  .auth-card {
    padding: 2rem 1.5rem;
    margin: 1rem;
    border-radius: 16px;
  }
  .auth-title {
    font-size: 1.75rem;
  }
  .auth-subtitle {
    font-size: 0.95rem;
  }
  .modern-input {
    padding: 0.875rem 1rem;
  }
  .modern-submit-btn {
    padding: 0.875rem 1.5rem;
  }
  .subscribe-card {
    padding: 2rem;
    margin: 1rem;
  }
  .missionary-name {
    font-size: 1.75rem;
  }
  .error-code {
    font-size: 6rem;
  }
  .error-title {
    font-size: 2rem;
  }
  .about-title {
    font-size: 2.5rem;
  }
  .steps-grid {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  .error-actions {
    flex-direction: column;
    align-items: center;
  }
  .plans-grid {
    grid-template-columns: 1fr;
  }
  .plan-option {
    padding: 1.5rem;
  }
  .price-amount {
    font-size: 2rem;
  }
}
/* Unsubscribe Page */
.unsubscribe-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}
.unsubscribe-container {
  padding: 4rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
}
.unsubscribe-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  text-align: center;
}
.unsubscribe-card h2 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1rem;
}
.unsubscribe-card p {
  color: #6c757d;
  margin-bottom: 2rem;
}
.unsubscribe-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: left;
}
.unsubscribe-btn {
  background: linear-gradient(45deg, #dc3545, #c82333);
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-weight: 600;
  color: white;
  transition: all 0.3s ease;
}
.unsubscribe-btn:hover:not(:disabled) {
  background: linear-gradient(45deg, #c82333, #dc3545);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}
.unsubscribe-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/* Loading Animation */
@keyframes bounceAndRotate {
  0% {
    transform: translateY(0) scale(1, 1) rotate(0deg);
  }
  20% {
    transform: translateY(-10px) scale(1.1, 0.9) rotate(0deg);
  }
  40% {
    transform: translateY(-100px) scale(1.1, 0.9) rotate(180deg);
  }
  60% {
    transform: translateY(10px) scale(0.9, 1.1) rotate(360deg);
  }
  70% {
    transform: translateY(0) scale(1, 1) rotate(360deg);
  }
  100% {
    transform: translateY(0) scale(1, 1) rotate(360deg);
  }
}
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.bouncing-logo {
  width: 100px;
  height: auto;
  animation: bounceAndRotate 2s ease-in-out infinite;
}
/* Responsive Design for Pricing */
@media (max-width: 768px) {
  .pricing-title {
    font-size: 2.2rem;
  }
  .pricing-subtitle {
    font-size: 1.1rem;
  }
  .pricing-hero {
    padding: 60px 0 40px;
  }
  .plans-section {
    padding: 40px 0 60px;
  }
  .price-amount {
    font-size: 2.5rem;
  }
  .unsubscribe-card {
    padding: 2rem;
    margin: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/main.less"],"names":[],"mappings":"AAAA,yCAAyC;AACzC,4DAA4D;AAI5D;EACI,wBAAA;EACA,sBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAFJ;AACA;;;;;;;;;;;CAWC;AACD;;;;;;;;;;;CAWC;AACD;;;;;;;;;;;CAWC;AACD;;;;;;;;;;;CAWC;AACD,oBAAoB;AASpB;EACI,qFAAA;EACA,iBAAA;AAPJ;AACA,iBAAiB;AAUjB;EACI,qIAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AARJ;AAWA;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;AATJ;AAYA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAaA;EACI,oEAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AAXJ;AAcA;EACI,2BAAA;EACA,yCAAA;EACA,oEAAA;AAZJ;AACA,yBAAyB;AAezB;EACI,mBAAA;EACA,eAAA;AAbJ;AAgBA;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAdJ;AAiBA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,YAAA;AAfJ;AAkBA;EACI,2BAAA;EACA,2CAAA;AAhBJ;AAmBA;EACI,WAAA;EACA,YAAA;EACA,gFAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAjBJ;AAoBA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAlBJ;AAqBA;EACI,cAAA;EACA,gBAAA;EACA,SAAA;AAnBJ;AAsBA;EACI,gBAAA;AApBJ;AAwBA;EACI;IAAO,UAAA;EArBT;EAsBE;IAAK,UAAA;EAnBP;AACF;AACA,sBAAsB;AAqBtB;EACI;IACI,iBAAA;EAnBN;EAsBE;IACI,iBAAA;EApBN;EAuBE;IACI,eAAA;EArBN;EAwBE;IACI,eAAA;EAtBN;EAyBE;IACI,eAAA;EAvBN;AACF;AA0BA;EACI,iCAAA;EACA,UAAA;EACA,6BAAA;AAxBJ;AA2BA;EACI;IACI,UAAA;IACA,4BAAA;EAzBN;EA2BE;IACI,UAAA;IACA,wBAAA;EAzBN;AACF;AA4BA;EACI,UAAA;EACA,4BAAA;EACA,0DAAA;AA1BJ;AA6BA;EACI,UAAA;EACA,wBAAA;AA3BJ;AA8BA;EACI,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;EACA,kBAAA;AA5BJ;AA+BA;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,kDAAA;AA7BJ;AAgCA;EACI,cAAA;EACA,UAAA;AA9BJ;AAiCA;EACI,yBAAA;EACA,UAAA;AA/BJ;AAmCA;EACI,uBAAA;EACA,cAAA;EAjCF,oCAAoC;EAkClC,2BAAA;AAhCJ;AAmCA;EACI,oCAAA;EACA,uBAAA;EACA,gBAAA;AAjCJ;AAoCA;EACI,yBAAA;EACA,uBAAA;EAlCF,4BAA4B;AAC9B;AAoCA;EACI,aAAA;AAlCJ;AAqCA;EACI,kBAAA;AAnCJ;AAsCA;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AApCJ;AAuCA;EACI,WAAA;EACA,YAAA;AArCJ;AAwCA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,2BAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;AAtCJ;AAyCA;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AAvCJ;AA0CA;EACI,WAAA;EACA,YAAA;AAxCJ;AACA,iBAAiB;AA2CjB;EACI,uCAAA;EACA,mCAAA;AAzCJ;AA4CA;EACI,UAAA;EACA,2BAAA;EACA,mBAAA;AA1CJ;AACA,8CAA8C;AA6C9C;EACI;IACI,uBAAA;EA3CN;EA6CE;IACI,yBAAA;EA3CN;AACF;AA8CA;EACI,kCAAA;EACA,4BAAA;AA5CJ;AA+CA;EACI,6BAAA;AA7CJ;AACA,2BAA2B;AAgD3B;EACI,0CAAA;AA9CJ;AAiDA;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AA/CJ;AAkDA;EACI,sBAAA;AAhDJ;AAmDA;EACI,qCAAA;EACA,sCAAA;AAjDJ;AACA,sBAAsB;AAoDtB;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,uBAAA;AAlDJ;AACA,6CAA6C;AAqD7C;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;AAnDJ;AAsDA;EACI,UAAA;AApDJ;AAuDA;EACI,mBAAA;AArDJ;AAwDA;EACI,gBAAA;EACA,kBAAA;AAtDJ;AACA,6BAA6B;AAyD7B;EACI,uBAAA;EACA,gBAAA;AAvDJ;AA0DA;EACI,yBAAA;AAxDJ;AA2DA;EACI,wBAAA;EACA,mCAAA;AAzDJ;AA4DA;EACI,yBAAA;AA1DJ;AA6DA;EACI,sBAAA;EACA,mCAAA;AA3DJ;AA8DA;EACI,2BAAA;EACA,eAAA;EACA,oBAAA;AA5DJ;AA+DA;EACI,UAAA;EACA,WAAA;AA7DJ;AACA,wBAAwB;AAgExB;EACI,qFAAA;EACA,iBAAA;AA9DJ;AACA,yBAAyB;AAiEzB;EACI,qFAAA;EACA,YAAA;EACA,qBAAA;AA/DJ;AAkEA;EACI,eAAA;EACA,gBAAA;EACA,yCAAA;AAhEJ;AAmEA;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAjEJ;AACA,kBAAkB;AAoElB;EACI,mBAAA;EACA,qBAAA;AAlEJ;AACA,kBAAkB;AAqElB;EACI,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AAnEJ;AAsEA;EACI,4BAAA;EACA,2CAAA;AApEJ;AAuEA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AArEJ;AAwEA;EACI,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;AAtEJ;AAyEA;EACI,iBAAA;EACA,6BAAA;EACA,gBAAA;AAvEJ;AA0EA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAxEJ;AA2EA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAzEJ;AA4EA;EACI,gFAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA1EJ;AA6EA;EACI,gFAAA;EACA,2BAAA;EACA,yCAAA;AA3EJ;AACA,qBAAqB;AA8ErB;EACI,6DAAA;EACA,iBAAA;AA5EJ;AA+EA;EACI,eAAA;AA7EJ;AACA,yBAAyB;AAgFzB;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AA9EJ;AAiFA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,YAAA;EACA,oDAAA;AA/EJ;AAkFA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,2BAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;EACA,0CAAA;AAhFJ;AAmFA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjFJ;AAoFA;EACI,4BAAA;AAlFJ;AAqFA;EACI,UAAA;EACA,4BAAA;EACA,mBAAA;AAnFJ;AACA,oBAAoB;AAsFpB;EACI,mBAAA;EACA,eAAA;AApFJ;AAuFA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AArFJ;AAwFA;EACI,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAtFJ;AAyFA;EACI,2BAAA;EACA,0CAAA;AAvFJ;AA0FA;EACI,oDAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AAxFJ;AA2FA;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;AAzFJ;AA4FA;EACI,mBAAA;EACA,YAAA;AA1FJ;AACA,oBAAoB;AA6FpB;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,yBAAA;EACA,YAAA;AA3FJ;AA8FA;EACI,2BAAA;EACA,0CAAA;AA5FJ;AACA,qBAAqB;AA+FrB;EACI,eAAA;AA7FJ;AACA,mBAAmB;AAgGnB;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9FJ;AAiGA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AA/FJ;AACA,uBAAuB;AAkGvB;EACI,aAAA;EACA,WAAA;AAhGJ;AAmGA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAjGJ;AAoGA;EACI,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAlGJ;AAqGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAnGJ;AACA,wBAAwB;AAsGxB;EACI,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,mBAAA;EACA,kBAAA;AApGJ;AAuGA;EACI,cAAA;EACA,qBAAA;AArGJ;AAwGA;EACI,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,mBAAA;EACA,kBAAA;AAtGJ;AAyGA;EACI,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAvGJ;AA0GA;EACI,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;AAxGJ;AA2GA;EACI;IAAK,UAAA;EAxGP;EAyGE;IAAM,YAAA;EAtGR;EAuGE;IAAO,UAAA;EApGT;AACF;AAsGA;EACI,cAAA;EACA,qBAAA;AApGJ;AAuGA;EACI,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AArGJ;AACA,oBAAoB;AAwGpB;EACI,kBAAA;AAtGJ;AAyGA;EACI,aAAA;EACA,uBAAA;AAvGJ;AA0GA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AAxGJ;AA2GA;EACI,cAAA;AAzGJ;AA4GA;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA1GJ;AA6GA;EACI,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,OAAA;AA3GJ;AA8GA;EACI,aAAA;EACA,WAAA;EACA,cAAA;AA5GJ;AACA,qBAAqB;AA+GrB;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AA7GJ;AAgHA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AA9GJ;AAiHA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AA/GJ;AAkHA;EACI,iBAAA;EACA,gBAAA;AAhHJ;AAmHA;EACI,SAAA;AAjHJ;AAoHA;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAlHJ;AAqHA;EACI,kBAAA;EACA,6BAAA;EACA,sBAAA;AAnHJ;AAsHA;EACI,yBAAA;AApHJ;AACA,gCAAgC;AAuHhC;EACI,6DAAA;EACA,iBAAA;AArHJ;AAwHA;EACI,eAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAtHJ;AAyHA;EACI,gBAAA;AAvHJ;AACA,cAAc;AA0Hd;EACI,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0CAAA;AAxHJ;AACA,gBAAgB;AA2HhB;EACI,kBAAA;EACA,mBAAA;AAzHJ;AA4HA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AA1HJ;AA6HA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AA3HJ;AACA,qBAAqB;AA8HrB;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AA5HJ;AA+HA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AA7HJ;AACA,iBAAiB;AAgIjB;EACI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AA9HJ;AAiIA;EACI,qBAAA;EACA,iBAAA;EACA,8CAAA;AA/HJ;AAkIA;EACI,cAAA;AAhIJ;AACA,yBAAyB;AAmIzB;EACI,WAAA;EACA,kBAAA;EACA,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;AAjIJ;AAoIA;EACI,2BAAA;EACA,+CAAA;EACA,oDAAA;AAlIJ;AAqIA;EACI,YAAA;EACA,mBAAA;EACA,eAAA;AAnIJ;AACA,eAAe;AAsIf;EACI,mBAAA;EACA,YAAA;EACA,+CAAA;EACA,cAAA;EACA,qBAAA;AApIJ;AAuIA;EACI,SAAA;EACA,qBAAA;AArIJ;AAwIA;EACI,sBAAA;AAtIJ;AACA,gBAAgB;AAyIhB;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAvIJ;AA0IA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AAxIJ;AA2IA;EACI,cAAA;EACA,oCAAA;EACA,qBAAA;AAzIJ;AACA,oBAAoB;AA4IpB;EACI,iBAAA;EACA,kBAAA;AA1IJ;AA6IA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AA3IJ;AA8IA;EACI,cAAA;EACA,0BAAA;AA5IJ;AACA,uBAAuB;AA+IvB;EACI,qDAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AA7IJ;AAgJA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AA9IJ;AAiJA;EACI,SAAA;EACA,mBAAA;EACA,cAAA;AA/IJ;AAkJA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AAhJJ;AAmJA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;AAjJJ;AAoJA;EACI,0BAAA;AAlJJ;AACA,oBAAoB;AAqJpB;EACI,kBAAA;EACA,kBAAA;AAnJJ;AAsJA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AApJJ;AAuJA;EACI,cAAA;EACA,SAAA;EACA,gBAAA;AArJJ;AACA,oCAAoC;AAwJpC;EACI;IACI,eAAA;EAtJN;EAyJE;IACI,eAAA;IACA,mBAAA;EAvJN;EA0JE;IACI,YAAA;IACA,WAAA;EAxJN;EA2JE;IACI,sBAAA;EAzJN;EA4JE;IACI,eAAA;EA1JN;EA6JE;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,oBAAA;EA3JN;EA8JE;;IAEI,qBAAA;EA5JN;AACF;AACA,kBAAkB;AA+JlB;EACI,qCAAA;EACA,2BAAA;EACA,2CAAA;EACA,eAAA;EACA,yCAAA;AA7JJ;AAgKA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA9JJ;AAiKA;EACI,WAAA;EACA,YAAA;AA/JJ;AAkKA;EACI,gBAAA;EACA,cAAA;AAhKJ;AAmKA;EACI,SAAA;AAjKJ;AAoKA;EACI,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AAlKJ;AAqKA;EACI,cAAA;EACA,oCAAA;AAnKJ;AAsKA;EACI,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AApKJ;AAuKA;EACI,YAAA;EACA,2BAAA;EACA,+CAAA;AArKJ;AAwKA;EACI,cAAA;EACA,kCAAA;AAtKJ;AACA,iBAAiB;AAyKjB;EACI,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;AAvKJ;AA0KA;EACI,gCAAA;EACA,uBAAA;EACA,WAAA;AAxKJ;AAqKA;EAMQ,YAAA;AAxKR;AA4KA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;AA1KJ;AA6KA;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EA3KF,8BAA8B;AAChC;AA6KA;EACI,6BAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AA3KJ;AA8KA;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;AA5KJ;AA+KA;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;AA7KJ;AAgLA;EACI,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AA9KJ;AAiLA;EACI,oDAAA;EACA,2BAAA;AA/KJ;AAkLA;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;AAhLJ;AACA,mBAAmB;AAmLnB;EACI,6DAAA;EACA,iBAAA;AAjLJ;AAoLA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;AAlLJ;AAqLA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;AAnLJ;AAsLA;EACI,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AApLJ;AAuLA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArLJ;AAwLA;EACI,iBAAA;EACA,cAAA;EACA,qBAAA;AAtLJ;AAyLA;EACI,cAAA;EACA,SAAA;AAvLJ;AA0LA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAxLJ;AA2LA;EACI,kBAAA;EACA,mBAAA;AAzLJ;AA4LA;EACI,cAAA;EACA,gBAAA;EACA,qBAAA;AA1LJ;AA6LA;EACI,cAAA;EACA,SAAA;AA3LJ;AA8LA;EACI,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AA5LJ;AA+LA;EACI,oDAAA;EACA,2BAAA;EACA,+CAAA;AA7LJ;AAgMA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AA9LJ;AAiMA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AA/LJ;AAkMA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAhMJ;AAmMA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AAjMJ;AAoMA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAlMJ;AACA,mBAAmB;AAqMnB;EACI,6DAAA;EACA,iBAAA;AAnMJ;AAsMA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AApMJ;AAuMA;EACI,YAAA;EACA,kBAAA;AArMJ;AAwMA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;AAtMJ;AAyMA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAvMJ;AA0MA;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;AAxMJ;AA2MA;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAzMJ;AA4MA;EACI,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA1MJ;AA6MA;EACI,mBAAA;EACA,cAAA;EACA,2BAAA;AA3MJ;AACA,eAAe;AA8Mf;EACI,6DAAA;EACA,iBAAA;AA5MJ;AA+MA;EACI,6DAAA;EACA,YAAA;EACA,qBAAA;AA7MJ;AAgNA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AA9MJ;AAiNA;EACI,iBAAA;EACA,YAAA;EACA,SAAA;AA/MJ;AAkNA;EACI,eAAA;AAhNJ;AAmNA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AAjNJ;AAoNA;EACI,mBAAA;EACA,kBAAA;AAlNJ;AAqNA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAnNJ;AAsNA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AApNJ;AAuNA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AArNJ;AAwNA;EACI,kBAAA;EACA,UAAA;AAtNJ;AAyNA;EACI,WAAA;EACA,YAAA;EACA,oDAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAvNJ;AA0NA;EACI,cAAA;EACA,gBAAA;EACA,qBAAA;AAxNJ;AA2NA;EACI,kBAAA;EACA,aAAA;EACA,qDAAA;EACA,mBAAA;AAzNJ;AA4NA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AA1NJ;AACA,iBAAiB;AA6NjB;EACI,6DAAA;EACA,iBAAA;AA3NJ;AA8NA;EACI,eAAA;AA5NJ;AA+NA;EACI,kBAAA;EACA,kBAAA;AA7NJ;AACA,sBAAsB;AAgOtB;EACK,gBAAA;AA9NL;AAiOA;EACI,eAAA;AA/NJ;AAkOA;EACI,kBAAA;EACA,kBAAA;AAhOJ;AAmOA;EACI,gBAAA;EACA,cAAA;AAjOJ;AAoOA;EACI,mBAAA;AAlOJ;AAqOA;EACI,aAAA;EACA,WAAA;EACA,2DAAA;AAnOJ;AAsOA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AApOJ;AAuOA;EACI,oCAAA;EACA,2BAAA;EACA,yCAAA;AArOJ;AAwOA;EACI,qBAAA;AAtOJ;AAyOA;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAvOJ;AA0OA;EACI,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;AAxOJ;AA2OA;EACI,iBAAA;EACA,gBAAA;EACA,6BAAA;AAzOJ;AA4OA;EACI,eAAA;EACA,cAAA;AA1OJ;AA6OA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;AA3OJ;AA8OA;EACI,gFAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AA5OJ;AA+OA;EACI,gFAAA;EACA,2BAAA;EACA,yCAAA;AA7OJ;AAgPA;EACI,YAAA;EACA,mBAAA;AA9OJ;AAiPA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AA/OJ;AACA,qCAAqC;AAkPrC;EACI;IACI,eAAA;EAhPN;EAmPE;IACI,oBAAA;IACA,YAAA;IACA,mBAAA;EAjPN;EAoPE;IACI,kBAAA;EAlPN;EAqPE;IACI,kBAAA;EAnPN;EAsPE;IACI,sBAAA;EApPN;EAuPE;IACI,wBAAA;EArPN;EAwPE;IACI,aAAA;IACA,YAAA;EAtPN;EAyPE;IACI,kBAAA;EAvPN;EA0PE;IACI,eAAA;EAxPN;EA2PE;IACI,eAAA;EAzPN;EA4PE;IACI,iBAAA;EA1PN;EA6PE;IACI,aAAA;IACA,sBAAA;IACA,YAAA;EA3PN;EA8PE;IACI,sBAAA;IACA,mBAAA;EA5PN;EA+PE;IACI,0BAAA;EA7PN;EAgQE;IACI,eAAA;EA9PN;EAiQE;IACI,eAAA;EA/PN;AACF;AACA,qBAAqB;AAkQrB;EACI,6DAAA;EACA,iBAAA;AAhQJ;AAmQA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;AAjQJ;AAoQA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAlQJ;AAqQA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAnQJ;AAsQA;EACI,cAAA;EACA,mBAAA;AApQJ;AAuQA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AArQJ;AAwQA;EACI,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AAtQJ;AAyQA;EACI,oDAAA;EACA,2BAAA;EACA,6CAAA;AAvQJ;AA0QA;EACI,YAAA;EACA,mBAAA;AAxQJ;AACA,sBAAsB;AA2QtB;EACI;IACI,iDAAA;EAzQN;EA2QE;IACI,yDAAA;EAzQN;EA2QE;IACI,4DAAA;EAzQN;EA2QE;IACI,0DAAA;EAzQN;EA2QE;IACI,mDAAA;EAzQN;EA2QE;IACI,mDAAA;EAzQN;AACF;AA4QA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA1QJ;AA6QA;EACI,YAAA;EACA,YAAA;EACA,kDAAA;AA3QJ;AACA,kCAAkC;AA8QlC;EACI;IACI,iBAAA;EA5QN;EA+QE;IACI,iBAAA;EA7QN;EAgRE;IACI,oBAAA;EA9QN;EAiRE;IACI,oBAAA;EA/QN;EAkRE;IACI,iBAAA;EAhRN;EAmRE;IACI,aAAA;IACA,YAAA;EAjRN;AACF","sourcesContent":["@base-url: \"http://localhost:3000\";\n\n/* Color Schemes - Uncomment one to use */\n\n/* Active: Dark Mystical (Deep purples and midnight blues) */\n:root {\n    --primary-start: #2d1b69;\n    --primary-end: #11998e;\n    --secondary-start: #667eea;\n    --secondary-end: #764ba2;\n    --accent-start: #4facfe;\n    --accent-end: #00f2fe;\n    --cta-start: #667eea;\n    --cta-end: #764ba2;\n}\n\n/* Option 1: Cosmic Noir (Black and deep space blues)\n:root {\n    --primary-start: #0c0c0c;\n    --primary-end: #1a237e;\n    --secondary-start: #283593;\n    --secondary-end: #1a237e;\n    --accent-start: #3f51b5;\n    --accent-end: #9c27b0;\n    --cta-start: #e91e63;\n    --cta-end: #9c27b0;\n}\n*/\n\n/* Option 2: Enchanted Forest (Deep greens and earth tones)\n:root {\n    --primary-start: #1b5e20;\n    --primary-end: #2e7d32;\n    --secondary-start: #388e3c;\n    --secondary-end: #1b5e20;\n    --accent-start: #4caf50;\n    --accent-end: #2e7d32;\n    --cta-start: #ff6f00;\n    --cta-end: #e65100;\n}\n*/\n\n/* Option 3: Dragon's Lair (Deep reds and charcoal)\n:root {\n    --primary-start: #1a1a1a;\n    --primary-end: #b71c1c;\n    --secondary-start: #d32f2f;\n    --secondary-end: #b71c1c;\n    --accent-start: #f44336;\n    --accent-end: #d32f2f;\n    --cta-start: #ff5722;\n    --cta-end: #d84315;\n}\n*/\n\n/* Option 4: Ethereal Mist (Soft purples and silvers)\n:root {\n    --primary-start: #4a148c;\n    --primary-end: #6a1b9a;\n    --secondary-start: #7b1fa2;\n    --secondary-end: #4a148c;\n    --accent-start: #9c27b0;\n    --accent-end: #7b1fa2;\n    --cta-start: #e1bee7;\n    --cta-end: #ce93d8;\n}\n*/\n\n/* Homepage Styles */\n.homepage {\n    background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);\n    min-height: 100vh;\n}\n\n/* Hero Section */\n.hero-section {\n    background: linear-gradient(135deg, rgba(45, 27, 105, 0.8) 0%, rgba(17, 153, 142, 0.8) 100%), url('/public/intro-pic.jpg');\n    background-size: cover;\n    background-position: center;\n    background-attachment: fixed;\n    color: white;\n    padding: 100px 0;\n    min-height: 80vh;\n    display: flex;\n    align-items: center;\n}\n\n.hero-title {\n    font-size: 3.5rem;\n    font-weight: 700;\n    margin-bottom: 1.5rem;\n    text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.hero-subtitle {\n    font-size: 1.25rem;\n    font-weight: 300;\n    opacity: 0.9;\n    max-width: 600px;\n    margin: 0 auto 2rem;\n    line-height: 1.6;\n}\n\n.cta-button {\n    background: linear-gradient(45deg, var(--cta-start), var(--cta-end));\n    border: none;\n    border-radius: 50px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.2);\n}\n\n.cta-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0,0,0,0.3);\n    background: linear-gradient(45deg, var(--cta-end), var(--cta-start));\n}\n\n/* How It Works Section */\n.how-it-works-section {\n    background: #f8f9fa;\n    padding: 80px 0;\n}\n\n.section-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: #2c3e50;\n    margin-bottom: 3rem;\n}\n\n.step-card {\n    text-align: center;\n    padding: 2rem 1rem;\n    background: white;\n    border-radius: 15px;\n    box-shadow: 0 5px 15px rgba(0,0,0,0.08);\n    transition: all 0.3s ease;\n    height: 100%;\n}\n\n.step-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px rgba(0,0,0,0.15);\n}\n\n.step-number {\n    width: 60px;\n    height: 60px;\n    background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin: 0 auto 1.5rem;\n}\n\n.step-card h4 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.step-card p {\n    color: #6c757d;\n    line-height: 1.6;\n    margin: 0;\n}\n\n.min-vh-75 {\n    min-height: 75vh;\n}\n\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .hero-title {\n        font-size: 2.5rem;\n    }\n    \n    .hero-subtitle {\n        font-size: 1.1rem;\n    }\n    \n    .section-title {\n        font-size: 2rem;\n    }\n    \n    .hero-section {\n        padding: 60px 0;\n    }\n    \n    .how-it-works-section {\n        padding: 60px 0;\n    }\n}\n\n.fade-up {\n    animation: fadeInUp 1.5s ease-out;\n    opacity: 0;\n    animation-fill-mode: forwards;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(200px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.scroll-animation {\n    opacity: 0;\n    transform: translateY(200px);\n    transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animation.fade-up {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.custom-input {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    margin-bottom: 2em\n}\n\n.custom-input:focus {\n    color: #212529;\n    background-color: #fff;\n    border-color: #86b7fe;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(13,110,253,.25);\n}\n\n.custom-input::placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.custom-input:disabled {\n    background-color: #e9ecef;\n    opacity: 1;\n}\n\n\n.tab {\n    background-color: white;\n    color: #6c757d;  /* Darker color for inactive links */\n    transition: color 0.2s ease;\n}\n\n.tab.active {\n    background-color: #848688 !important;\n    color: black !important;\n    font-weight: 500;\n}\n\n.tab:hover {\n    background-color: #bbbdc0;\n    color: black !important;  /* Same as active on hover */\n}\n\n.action-button-wrapper {\n    z-index: 1000;\n}\n\n.action-button {\n    position: relative;\n}\n\n.main-button {\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.3s ease;\n}\n\n.main-button svg {\n    width: 24px;\n    height: 24px;\n}\n\n.expanded-buttons {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    opacity: 0;\n    transform: translateX(10px);\n    pointer-events: none;\n    transition: all 0.3s ease;\n    border-radius: 24px 0 0 24px;\n    overflow: hidden;\n}\n\n.action-item {\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-right: 1px solid rgba(0,0,0,0.1);\n}\n\n.action-item svg {\n    width: 20px;\n    height: 20px;\n}\n\n/* Hover states */\n.action-button:hover .main-button {\n    border-radius: 0 24px 24px 0 !important;\n    transition: border-radius 0.3s ease;\n}\n\n.action-button:hover .expanded-buttons {\n    opacity: 1;\n    transform: translateX(-3em);\n    pointer-events: all;\n}\n\n/* Optional: Add animation for the gear icon */\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.main-button svg {\n    animation: spin 4s linear infinite;\n    animation-play-state: paused;\n}\n\n.action-button:hover .main-button svg {\n    animation-play-state: running;\n}\n\n/* Add to your stylesheet */\n.table {\n    --bs-table-striped-bg: rgba(0, 0, 0, 0.02);\n}\n\n.table th {\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.875rem;\n    letter-spacing: 0.5px;\n}\n\n.table td {\n    vertical-align: middle;\n}\n\n.table-hover tbody tr:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    transition: background-color 0.2s ease;\n}\n\n/* For sticky header */\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: white;\n}\n\n/* Custom scrollbar for the table container */\n.table-container {\n    max-height: 400px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n\n.table-container::-webkit-scrollbar {\n    width: 6px;\n}\n\n.table-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n}\n\n/* Responsive table wrapper */\n.table-responsive {\n    border-radius: 0.375rem;\n    overflow: hidden;\n}\n\n.transition-icon {\n    transition: all 0.2s ease;\n}\n\n.transition-icon:hover {\n    transform: rotate(90deg);\n    color: var(--bs-primary) !important;\n}\n\n.transition-icon-2 {\n    transition: all 0.2s ease;\n}\n\n.transition-icon-2:hover {\n    transform: scale(1.25);\n    color: var(--bs-primary) !important;\n}\n\n.link-box {\n    background-color: '#f8f9fa';\n    padding: '10px';\n    border-radius: '4px';\n}\n\n.intro-pic {\n    width: 100;\n    z-index: -1;\n}\n\n/* Pricing Page Styles */\n.pricing-page {\n    background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);\n    min-height: 100vh;\n}\n\n/* Pricing Hero Section */\n.pricing-hero {\n    background: linear-gradient(135deg, var(--primary-start) 0%, var(--primary-end) 100%);\n    color: white;\n    padding: 100px 0 60px;\n}\n\n.pricing-title {\n    font-size: 3rem;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.pricing-subtitle {\n    font-size: 1.2rem;\n    font-weight: 300;\n    opacity: 0.9;\n    max-width: 600px;\n    margin: 0 auto;\n    line-height: 1.6;\n}\n\n/* Plans Section */\n.plans-section {\n    background: #f8f9fa;\n    padding: 60px 0 100px;\n}\n\n/* Pricing Cards */\n.pricing-card {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n    transition: all 0.3s ease;\n    overflow: hidden;\n}\n\n.pricing-card:hover {\n    transform: translateY(-10px);\n    box-shadow: 0 20px 40px rgba(0,0,0,0.15);\n}\n\n.plan-name {\n    color: #2c3e50;\n    font-weight: 600;\n    font-size: 1.5rem;\n}\n\n.price-container {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 0.25rem;\n}\n\n.price-symbol {\n    font-size: 1.5rem;\n    color: var(--secondary-start);\n    font-weight: 600;\n}\n\n.price-amount {\n    font-size: 3rem;\n    font-weight: 700;\n    color: #2c3e50;\n}\n\n.price-period {\n    font-size: 1rem;\n    color: #6c757d;\n    font-weight: 400;\n}\n\n.plan-button {\n    background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));\n    border: none;\n    border-radius: 50px;\n    font-weight: 600;\n    padding: 12px 30px;\n    transition: all 0.3s ease;\n}\n\n.plan-button:hover {\n    background: linear-gradient(45deg, var(--secondary-end), var(--secondary-start));\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0,0,0,0.4);\n}\n\n/* Dashboard Styles */\n.dashboard-page {\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    min-height: 100vh;\n}\n\n.dashboard-content {\n    padding: 2rem 0;\n}\n\n/* Modern Action Button */\n.modern-action-button {\n    position: fixed;\n    bottom: 2rem;\n    right: 2rem;\n    z-index: 1000;\n}\n\n.modern-action-button .main-button {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    border: none;\n    background: linear-gradient(45deg, #667eea, #764ba2);\n}\n\n.modern-action-button .expanded-buttons {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    opacity: 0;\n    transform: translateX(10px);\n    pointer-events: none;\n    transition: all 0.3s ease;\n    border-radius: 28px 0 0 28px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.modern-action-button .action-item {\n    width: 48px;\n    height: 48px;\n    border-radius: 0;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.modern-action-button:hover .main-button {\n    border-radius: 0 28px 28px 0;\n}\n\n.modern-action-button:hover .expanded-buttons {\n    opacity: 1;\n    transform: translateX(-48px);\n    pointer-events: all;\n}\n\n/* Missionary Tabs */\n.missionary-tabs-container {\n    margin-bottom: 2rem;\n    padding: 0 1rem;\n}\n\n.missionary-tabs {\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    padding-bottom: 0.5rem;\n}\n\n.missionary-tab {\n    background: white;\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 1.5rem;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n    transition: all 0.3s ease;\n    min-width: 200px;\n    text-align: left;\n}\n\n.missionary-tab:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.missionary-tab.active {\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    color: white;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.tab-name {\n    font-weight: 600;\n    font-size: 1rem;\n    margin-bottom: 0.25rem;\n}\n\n.tab-email {\n    font-size: 0.875rem;\n    opacity: 0.8;\n}\n\n/* Dashboard Cards */\n.dashboard-card {\n    background: white;\n    border-radius: 16px;\n    padding: 2rem;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n    transition: all 0.3s ease;\n    height: 100%;\n}\n\n.dashboard-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0,0,0,0.12);\n}\n\n/* Modern Dashboard */\n.modern-dashboard {\n    padding: 1rem 0;\n}\n\n/* Section Titles */\n.section-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 1rem;\n}\n\n.section-subtitle {\n    color: #6c757d;\n    font-size: 0.95rem;\n    line-height: 1.5;\n}\n\n/* Missionary Details */\n.modern-missionary-details .details-grid {\n    display: grid;\n    gap: 1.5rem;\n}\n\n.detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.detail-label {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #6c757d;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.detail-value {\n    font-size: 1rem;\n    font-weight: 500;\n    color: #2c3e50;\n}\n\n/* Subscription Status */\n.subscription-prompt {\n    margin-top: 2rem;\n    padding: 1.5rem;\n    background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n    border-radius: 12px;\n    text-align: center;\n}\n\n.subscription-prompt h5 {\n    color: #2c3e50;\n    margin-bottom: 0.5rem;\n}\n\n.status-active {\n    margin-top: 2rem;\n    padding: 1.5rem;\n    background: linear-gradient(135deg, #d4edda, #c3e6cb);\n    border-radius: 12px;\n    text-align: center;\n}\n\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #28a745;\n    color: white;\n    padding: 0.5rem 1rem;\n    border-radius: 20px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    margin-bottom: 1rem;\n}\n\n.status-dot {\n    width: 8px;\n    height: 8px;\n    background: white;\n    border-radius: 50%;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0% { opacity: 1; }\n    50% { opacity: 0.5; }\n    100% { opacity: 1; }\n}\n\n.status-active h5 {\n    color: #155724;\n    margin-bottom: 0.5rem;\n}\n\n.email-address {\n    background: white;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    font-family: monospace;\n    font-weight: 500;\n    color: #2c3e50;\n    border: 2px solid #28a745;\n}\n\n/* QR Code Section */\n.modern-qr-section {\n    text-align: center;\n}\n\n.qr-code-container {\n    display: flex;\n    justify-content: center;\n}\n\n.qr-code-wrapper {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n    display: inline-block;\n}\n\n.qr-code {\n    display: block;\n}\n\n.link-container {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.link-text {\n    font-family: monospace;\n    font-size: 0.875rem;\n    color: #495057;\n    word-break: break-all;\n    flex: 1;\n}\n\n.link-actions {\n    display: flex;\n    gap: 0.5rem;\n    flex-shrink: 0;\n}\n\n/* Subscriber Table */\n.modern-subscriber-table {\n    background: white;\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.table-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem 2rem;\n    background: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.edit-toggle-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n}\n\n.table-wrapper {\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.modern-table {\n    margin: 0;\n}\n\n.modern-table th {\n    background: #f8f9fa;\n    border-top: none;\n    font-weight: 600;\n    color: #495057;\n    padding: 1rem 2rem;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.modern-table td {\n    padding: 1rem 2rem;\n    border-top: 1px solid #f1f3f4;\n    vertical-align: middle;\n}\n\n.modern-table tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n/* Authentication Pages Styles */\n.auth-page {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    min-height: 100vh;\n}\n\n.auth-container {\n    padding: 2rem 0;\n    min-height: calc(100vh - 80px);\n    display: flex;\n    align-items: center;\n}\n\n.min-vh-80 {\n    min-height: 80vh;\n}\n\n/* Auth Card */\n.auth-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem 2.5rem;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255,255,255,0.2);\n}\n\n/* Auth Header */\n.auth-header {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.auth-title {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #2c3e50;\n    margin-bottom: 0.75rem;\n}\n\n.auth-subtitle {\n    color: #6c757d;\n    font-size: 1rem;\n    line-height: 1.5;\n    margin: 0;\n}\n\n/* Modern Auth Form */\n.modern-auth-form {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n/* Modern Input */\n.modern-input {\n    width: 100%;\n    padding: 1rem 1.25rem;\n    font-size: 1rem;\n    border: 2px solid #e9ecef;\n    border-radius: 12px;\n    background: #f8f9fa;\n    transition: all 0.3s ease;\n    outline: none;\n}\n\n.modern-input:focus {\n    border-color: #667eea;\n    background: white;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.modern-input::placeholder {\n    color: #adb5bd;\n}\n\n/* Modern Submit Button */\n.modern-submit-btn {\n    width: 100%;\n    padding: 1rem 2rem;\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    border: none;\n    border-radius: 12px;\n    color: white;\n    font-weight: 600;\n    font-size: 1rem;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.modern-submit-btn:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n    background: linear-gradient(45deg, #764ba2, #667eea);\n}\n\n.modern-submit-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Auth Error */\n.auth-error {\n    border-radius: 12px;\n    border: none;\n    background: linear-gradient(135deg, #fee, #fdd);\n    color: #721c24;\n    padding: 1rem 1.25rem;\n}\n\n.error-list {\n    margin: 0;\n    padding-left: 1.25rem;\n}\n\n.error-list li {\n    margin-bottom: 0.25rem;\n}\n\n/* Auth Toggle */\n.auth-toggle {\n    text-align: center;\n    margin-top: 1.5rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e9ecef;\n}\n\n.toggle-btn {\n    color: #667eea;\n    text-decoration: none;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n}\n\n.toggle-btn:hover {\n    color: #764ba2;\n    background: rgba(102, 126, 234, 0.1);\n    text-decoration: none;\n}\n\n/* Forgot Password */\n.forgot-password {\n    text-align: right;\n    margin-top: 0.5rem;\n}\n\n.forgot-link {\n    color: #667eea;\n    text-decoration: none;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: color 0.3s ease;\n}\n\n.forgot-link:hover {\n    color: #764ba2;\n    text-decoration: underline;\n}\n\n/* Missionary Warning */\n.missionary-warning {\n    background: linear-gradient(135deg, #fff3cd, #ffeaa7);\n    border-radius: 8px;\n    padding: 1rem;\n    margin-top: 0.5rem;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    cursor: pointer;\n    margin: 0;\n}\n\n.checkbox-input {\n    margin: 0;\n    margin-top: 0.25rem;\n    flex-shrink: 0;\n}\n\n.checkbox-text {\n    font-size: 0.875rem;\n    color: #856404;\n    line-height: 1.4;\n}\n\n.checkbox-text a {\n    color: #667eea;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.checkbox-text a:hover {\n    text-decoration: underline;\n}\n\n/* Success Message */\n.success-message {\n    text-align: center;\n    padding: 2rem 1rem;\n}\n\n.success-message h4 {\n    color: #28a745;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.success-message p {\n    color: #6c757d;\n    margin: 0;\n    line-height: 1.5;\n}\n\n/* Responsive Design for Dashboard */\n@media (max-width: 768px) {\n    .dashboard-content {\n        padding: 1rem 0;\n    }\n    \n    .dashboard-card {\n        padding: 1.5rem;\n        margin-bottom: 1rem;\n    }\n    \n    .modern-action-button {\n        bottom: 1rem;\n        right: 1rem;\n    }\n    \n    .missionary-tabs {\n        flex-direction: column;\n    }\n    \n    .missionary-tab {\n        min-width: auto;\n    }\n    \n    .table-header {\n        padding: 1rem;\n        flex-direction: column;\n        gap: 1rem;\n        align-items: stretch;\n    }\n    \n    .modern-table th,\n    .modern-table td {\n        padding: 0.75rem 1rem;\n    }\n}\n\n/* Header Styles */\n.modern-header {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    padding: 1rem 0;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.brand-logo {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    text-decoration: none;\n    color: #2c3e50;\n    font-weight: 600;\n    font-size: 1.25rem;\n}\n\n.logo-img {\n    width: 40px;\n    height: 40px;\n}\n\n.brand-text {\n    font-weight: 700;\n    color: #2c3e50;\n}\n\n.nav-links {\n    gap: 1rem;\n}\n\n.nav-item {\n    color: #495057;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n    text-decoration: none;\n}\n\n.nav-item:hover {\n    color: #667eea;\n    background: rgba(102, 126, 234, 0.1);\n}\n\n.signin-btn {\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    color: white;\n    border-radius: 20px;\n    padding: 0.5rem 1.5rem;\n}\n\n.signin-btn:hover {\n    color: white;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.logout-btn:hover {\n    color: #dc3545;\n    background: rgba(220, 53, 69, 0.1);\n}\n\n/* Modal Styles */\n.modal-content {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.15);\n    height: 75vh;\n}\n\n.modal-header {\n    border-bottom: 1px solid #f1f3f4;\n    padding: 2rem 2rem 1rem;\n    width: 100%;\n\n    .btn-close {\n        color: white;\n    }\n}\n\n.modal-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: whitesmoke;\n}\n\n.modal-body {\n    padding: 1rem 2rem;\n    overflow-y: auto;\n    width: 100%;\n    scrollbar-width: thin; /* Options: auto, thin, none */\n}\n\n.modal-footer {\n    border-top: 1px solid #f1f3f4;\n    padding: 1rem 2rem 2rem;\n    gap: 1rem;\n    width: 100%;\n}\n\n.form-label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 0.5rem;\n}\n\n.cancel-btn {\n    border-radius: 10px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n}\n\n.save-btn {\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    border: none;\n    border-radius: 10px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    color: white;\n}\n\n.save-btn:hover {\n    background: linear-gradient(45deg, #764ba2, #667eea);\n    transform: translateY(-1px);\n}\n\n.email-confirm {\n    background: #f8f9fa;\n    padding: 1rem;\n    border-radius: 8px;\n    font-family: monospace;\n    color: #495057;\n    border: 2px solid #e9ecef;\n}\n\n/* Subscribe Page */\n.subscribe-page {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    min-height: 100vh;\n}\n\n.subscribe-container {\n    padding: 4rem 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh - 80px);\n}\n\n.subscribe-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n    max-width: 500px;\n    width: 100%;\n}\n\n.missionary-info {\n    text-align: center;\n    margin-bottom: 2rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.missionary-name {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #2c3e50;\n    margin-bottom: 1rem;\n}\n\n.mission-details {\n    font-size: 1.1rem;\n    color: #495057;\n    margin-bottom: 0.5rem;\n}\n\n.start-date {\n    color: #6c757d;\n    margin: 0;\n}\n\n.subscribe-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.form-header {\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.form-header h3 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.form-header p {\n    color: #6c757d;\n    margin: 0;\n}\n\n.subscribe-btn {\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 2rem;\n    font-weight: 600;\n    color: white;\n    transition: all 0.3s ease;\n}\n\n.subscribe-btn:hover {\n    background: linear-gradient(45deg, #764ba2, #667eea);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.success-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    text-align: center;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n    max-width: 400px;\n}\n\n.success-icon {\n    width: 80px;\n    height: 80px;\n    background: #28a745;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2rem;\n    color: white;\n    margin: 0 auto 1.5rem;\n}\n\n.success-card h3 {\n    color: #28a745;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.error-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    text-align: center;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n    max-width: 400px;\n}\n\n.error-card h3 {\n    color: #dc3545;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n/* Not Found Page */\n.not-found-page {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    min-height: 100vh;\n}\n\n.not-found-container {\n    padding: 4rem 2rem;\n    display: flex;\n    align-items: center;\n    min-height: calc(100vh - 80px);\n}\n\n.not-found-content {\n    color: white;\n    text-align: center;\n}\n\n.error-code {\n    font-size: 8rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    text-shadow: 0 4px 8px rgba(0,0,0,0.3);\n}\n\n.error-title {\n    font-size: 2.5rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.error-message {\n    font-size: 1.2rem;\n    margin-bottom: 2rem;\n    opacity: 0.9;\n}\n\n.error-actions {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.home-btn {\n    background: white;\n    color: #667eea;\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 2rem;\n    font-weight: 600;\n}\n\n.home-btn:hover {\n    background: #f8f9fa;\n    color: #764ba2;\n    transform: translateY(-2px);\n}\n\n/* About Page */\n.about-page {\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    min-height: 100vh;\n}\n\n.about-hero {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 100px 0 60px;\n}\n\n.about-title {\n    font-size: 3rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n}\n\n.about-subtitle {\n    font-size: 1.2rem;\n    opacity: 0.9;\n    margin: 0;\n}\n\n.about-content {\n    padding: 4rem 0;\n}\n\n.content-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.mission-statement {\n    margin-bottom: 3rem;\n    text-align: center;\n}\n\n.mission-statement h2 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.how-it-works h2 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 2rem;\n    text-align: center;\n}\n\n.steps-grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 2rem;\n    justify-content: space-between;\n    align-items: stretch;\n    margin-bottom: 3rem;\n}\n\n.step-item {\n    text-align: center;\n    padding: 0; //1.5rem;\n}\n\n.step-number {\n    width: 60px;\n    height: 60px;\n    background: linear-gradient(45deg, #667eea, #764ba2);\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin: 0 auto 1rem;\n}\n\n.step-item h4 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.cta-section {\n    text-align: center;\n    padding: 2rem;\n    background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n    border-radius: 16px;\n}\n\n.cta-section h3 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n/* Content Page */\n.content-page {\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    min-height: 100vh;\n}\n\n.page-container {\n    padding: 4rem 0;\n}\n\n.loading-content {\n    text-align: center;\n    padding: 4rem 2rem;\n}\n\n/* Stripe Components */\n.modal-dialog {\n     max-width: 800px;\n}\n\n.stripe-form {\n    padding: 1rem 0;\n}\n\n.stripe-loading {\n    text-align: center;\n    padding: 3rem 2rem;\n}\n\n.stripe-loading p {\n    margin-top: 1rem;\n    color: #6c757d;\n}\n\n.plans-selection {\n    margin-bottom: 2rem;\n}\n\n.plans-grid {\n    display: grid;\n    gap: 1.5rem;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n}\n\n.plan-option {\n    border: 2px solid #e9ecef;\n    border-radius: 16px;\n    padding: 2rem;\n    text-align: center;\n    transition: all 0.3s ease;\n    background: white;\n}\n\n.plan-option:hover {\n    border-color: var(--secondary-start);\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0,0,0,0.1);\n}\n\n.plan-header {\n    margin-bottom: 1.5rem;\n}\n\n.plan-name {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 1rem;\n}\n\n.plan-price {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 0.25rem;\n}\n\n.price-amount {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: var(--secondary-start);\n}\n\n.price-period {\n    font-size: 1rem;\n    color: #6c757d;\n}\n\n.plan-description {\n    color: #6c757d;\n    margin-bottom: 2rem;\n    line-height: 1.5;\n}\n\n.select-plan-btn {\n    background: linear-gradient(45deg, var(--secondary-start), var(--secondary-end));\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 2rem;\n    font-weight: 600;\n    color: white;\n    width: 100%;\n    transition: all 0.3s ease;\n}\n\n.select-plan-btn:hover:not(:disabled) {\n    background: linear-gradient(45deg, var(--secondary-end), var(--secondary-start));\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0,0,0,0.2);\n}\n\n.select-plan-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.checkout-container {\n    min-height: 400px;\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n/* Responsive Design for Auth Pages */\n@media (max-width: 768px) {\n    .auth-container {\n        padding: 1rem 0;\n    }\n    \n    .auth-card {\n        padding: 2rem 1.5rem;\n        margin: 1rem;\n        border-radius: 16px;\n    }\n    \n    .auth-title {\n        font-size: 1.75rem;\n    }\n    \n    .auth-subtitle {\n        font-size: 0.95rem;\n    }\n    \n    .modern-input {\n        padding: 0.875rem 1rem;\n    }\n    \n    .modern-submit-btn {\n        padding: 0.875rem 1.5rem;\n    }\n    \n    .subscribe-card {\n        padding: 2rem;\n        margin: 1rem;\n    }\n    \n    .missionary-name {\n        font-size: 1.75rem;\n    }\n    \n    .error-code {\n        font-size: 6rem;\n    }\n    \n    .error-title {\n        font-size: 2rem;\n    }\n    \n    .about-title {\n        font-size: 2.5rem;\n    }\n    \n    .steps-grid {\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n    }\n    \n    .error-actions {\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .plans-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .plan-option {\n        padding: 1.5rem;\n    }\n    \n    .price-amount {\n        font-size: 2rem;\n    }\n}\n\n/* Unsubscribe Page */\n.unsubscribe-page {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    min-height: 100vh;\n}\n\n.unsubscribe-container {\n    padding: 4rem 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh - 80px);\n}\n\n.unsubscribe-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n    max-width: 500px;\n    width: 100%;\n    text-align: center;\n}\n\n.unsubscribe-card h2 {\n    color: #2c3e50;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.unsubscribe-card p {\n    color: #6c757d;\n    margin-bottom: 2rem;\n}\n\n.unsubscribe-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    text-align: left;\n}\n\n.unsubscribe-btn {\n    background: linear-gradient(45deg, #dc3545, #c82333);\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 2rem;\n    font-weight: 600;\n    color: white;\n    transition: all 0.3s ease;\n}\n\n.unsubscribe-btn:hover:not(:disabled) {\n    background: linear-gradient(45deg, #c82333, #dc3545);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);\n}\n\n.unsubscribe-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Loading Animation */\n@keyframes bounceAndRotate {\n    0% {\n        transform: translateY(0) scale(1, 1) rotate(0deg);\n    }\n    20% {\n        transform: translateY(-10px) scale(1.1, 0.9) rotate(0deg);\n    }\n    40% {\n        transform: translateY(-100px) scale(1.1, 0.9) rotate(180deg);\n    }\n    60% {\n        transform: translateY(10px) scale(0.9, 1.1) rotate(360deg);\n    }\n    70% {\n        transform: translateY(0) scale(1, 1) rotate(360deg);\n    }\n    100% {\n        transform: translateY(0) scale(1, 1) rotate(360deg);\n    }\n}\n\n.loading-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n}\n\n.bouncing-logo {\n    width: 100px;\n    height: auto;\n    animation: bounceAndRotate 2s ease-in-out infinite;\n}\n\n/* Responsive Design for Pricing */\n@media (max-width: 768px) {\n    .pricing-title {\n        font-size: 2.2rem;\n    }\n    \n    .pricing-subtitle {\n        font-size: 1.1rem;\n    }\n    \n    .pricing-hero {\n        padding: 60px 0 40px;\n    }\n    \n    .plans-section {\n        padding: 40px 0 60px;\n    }\n    \n    .price-amount {\n        font-size: 2.5rem;\n    }\n    \n    .unsubscribe-card {\n        padding: 2rem;\n        margin: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
